import { render, staticRenderFns } from "./HomeBanners.vue?vue&type=template&id=28c32136"
import script from "./HomeBanners.vue?vue&type=script&lang=js"
export * from "./HomeBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports